module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_31.00c22747.png";